import React from 'react';

const LineItemRowsLoader = () => (
    <>
        <td className="w-[40px] min-w-[40px] max-w-[40px] sticky left-0 bg-inherit z-[1] table-cell-with-tooltip !py-0">
            <div className="px-3 flex items-center h-full">
                <div className="custom-loading w-4 h-4 rounded flex-none" />
            </div>
        </td>
        <td className="min-w-[100px] w-[10.43%] max-w-[10.43%]">
            <span className="custom-loading">lor</span>
        </td>
        <td className="w-[12.43%] max-w-[12.43%]">
            <span className="custom-loading">Lorem</span>
        </td>
        <td className="w-[12.43%] max-w-[12.43%]">
            <span className="custom-loading">lorem ipsum</span>
        </td>
        <td className="w-[12.43%] max-w-[12.43%]">
            <span className="custom-loading">lor</span>
        </td>
        <td className="w-[13.43%] max-w-[13.43%]">
            <span className="custom-loading">lorem ip</span>
        </td>
        <td className="w-[13.43%] max-w-[13.43%]">
            <span className="custom-loading">lorem ip</span>
        </td>
        <td className="w-[12.43%] max-w-[12.43%]">
            <h6 className="truncate custom-loading">lorem ipsu</h6>
        </td>
        <td className="w-[13.43%] max-w-[13.43%]">
            <h6 className="truncate custom-loading">lorem ipsu</h6>
        </td>
    </>
);

export default LineItemRowsLoader;
